import { definePreset } from '../types/portal-settings';

// Same surface as towing-mapping. There is deliberately no helicopter layer:
// helicopter tenants run the generic fleet and mapping screens.
export default definePreset({
	homePage: 'fleet',
	pages: ['fleet', 'unitMap', 'units', 'settings'],
	allowApiOriginOverride: true,
	features: {
		twoFactorAuth: true,
		unitMapping: { enabled: true, allowMockData: true, routingStrategy: 'simple' },
	},
});
